import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AssociateCropService {

  seedAssociateOrderId: BehaviorSubject<number>;
  confirmationSeedAssociateOrderId: BehaviorSubject<number>;
  constructor(public configService: ConfigService, public networkService: NetworkService) {
    this.seedAssociateOrderId = new BehaviorSubject(0);
    this.confirmationSeedAssociateOrderId = new BehaviorSubject(0);
  }


  public setseedAssociateOrderId(value: number) {
    this.seedAssociateOrderId.next(value);
  }

  public setconfirmationSeedAssociateOrderId(value: number) {
    this.confirmationSeedAssociateOrderId.next(value);
  }
  submitedItem = false;

  // Get Seed Crop Associate Locations
  public getSeedCropAssociateLocations() {
    return this.networkService.getRequest(this.configService.getSeedCropAssociateLocations());
  }

  // Get Seed Crop Associate Ship To Account data
  public getSeedCropAssociateAccount() {
    return this.networkService.getRequest(this.configService.getSeedCropAssociateAccount());
  }

  // Get Seed Crop Associate Deliver To data
  public getSeedCropAssociateDeliverTo(accountNumber, parentAccountNumber) {
    return this.networkService.getRequest(this.configService.getSeedCropAssociateDeliverTo() + '?accountNumber=' + accountNumber + '&parentAccountNumber=' + parentAccountNumber);
  }

  // Get Seed Crop Associate Deliver To data
  public getSeedCropDetailsData(locationId, cropTypeCode) {
    return this.networkService.getRequest(this.configService.getSeedCropDetailsData() + '?locationId=' + locationId + '&cropTypeCode=' + cropTypeCode);
  }

  // Get Seed Crop Associate Deliver To data
  public getSeedCropPlaceRequest(order) {
    return this.networkService.postRequest(this.configService.getSeedCropPlaceRequest(), order);
  }

  // Get Seed Crop Associate Landing Data
  public GetSeedCropAssociatesLandingData(filter) {
    return this.networkService.postRequest(this.configService.GetSeedCropAssociatesLandingData(), filter);
  }
  // Get Seed Crop Associate Reconciliation Landing Data
  public GetSeedCropAssociatesReconciliationLandingData(filter) {
    return this.networkService.postRequest(this.configService.GetSeedCropAssociatesReconciliationLandingData(), filter);
  }

  // Get Seed Crop Associate Landing Data
  public GetSeedCropAssociatesOrderSummaryData(orderHeaderId) {
    return this.networkService.getRequest(this.configService.GetSeedCropAssociatesOrderSummaryData() + '?orderHeaderId=' + orderHeaderId);
  }

  public downloadPdfForMobile(summaryResult) {
    return this.networkService.postRequest(this.configService.GetSeedCropAssociatesPdfData(), summaryResult);
  }

  // pdf from base64 date
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.AssociatePostFileForPdf(), filters);
  }

  // Get Seed Crop Associate Report Data
  public getSeedCropAssociateReport() {
    return this.networkService.getRequest(this.configService.GetSeedCropReportData());
  }


  // Get Reconcile Variety
  public getReconcileVariety(orderHeaderID) {
    return this.networkService.getRequest(this.configService.GetReconcileVariety() + '?headerId=' + orderHeaderID);
  }

  // Add Update  Reconcile Order
  public AddUpdateReconcileOrder(order) {
    return this.networkService.postRequest(this.configService.AddUpdateReconcileOrder(), order);
  }

  // Get Inventory Location Landing Data
  public getInventoryLandingData(locationId) {
    return this.networkService.getRequest(this.configService.getInventoryLandingData() + '?locationId=' + locationId);
  }

  // Get Inventory Master Data

  public getInventoryMasterData() {
    return this.networkService.getRequest(this.configService.getInventoryMasterData());
  }

  // Get Inventory Location List

  public getInventoryLocationList() {
    return this.networkService.getRequest(this.configService.getInventoryLocationList());
  }


  // Add Update Inventory data
  public AddUpdateInvetoryOrder(order) {
    return this.networkService.postRequest(this.configService.AddUpdateInvetoryOrder(), order);
  }


}
